import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-powered-by-givi',
    templateUrl: './powered-by-givi.component.html',
    styleUrls: ['./powered-by-givi.component.scss']
})
export class PoweredByGiviComponent {

    // Si no se pasa (null/undefined/''), solo se muestra "Powered by Givi"
    @Input() vendorName: string | null | undefined = null;

    // Color del texto. Default negro.
    @Input() color = '#000';

    // Variante del logo de Givi. Default negro (para fondos claros).
    @Input() logo: 'azul' | 'blanco' | 'negro' = 'negro';

    get logoSrc(): string {

        return `assets/images/logo-givi-${this.logo}.png`;
    }
}
